import styled from 'styled-components'
/* --------------------------------------------- */
// Styled component for PlayerPlaceholder component
export const ImgContainer = styled.div`
${({ images }) => {
    if (!images) return
    return `
    {
      background-image: url("${images}");
      background-repeat: no-repeat;
      background-size: cover;
    }
    `
  }}
`
export const InfoTitleHeader = styled.div`
  color: ${({ theme: { header } }) => header && header.text.primary};
`

export const ListInfoWrapper = styled.div`
  overflow-y: auto;
  min-height: ${({ noOfLines }) => noOfLines > 4 ? '18em' : noOfLines > 2 ? '8em' : 'unset' };
  max-height: 18em;
  ::-webkit-scrollbar {
    width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey; 
    border-radius: 10px;
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #807070; 
    border-radius: 10px;
  }
  
`

export const InfoSubTitleHeader = styled.div`
  color: ${({ theme: { header } }) => header && header.text.secondary};
`

export const InfoDescriptionHeader = styled.div`
  color: ${({ theme: { header } }) => header && header.text.tertiary};
`

export const InfoSubTitle = styled.div`
  color: ${({ theme: { body } }) => body && body.text.secondary};
`
export const InfoTitle = styled.div`
  color: ${({ theme: { body } }) => body && body.text.primary};
`
export const InfoDesc = styled.div`
  color: ${({ theme: { body } }) => body && body.text.tertiary};
`
export const InfoCtaDesc = styled.div`
  color: ${({ theme: { body } }) => body && body.text.tertiary};
`
export const ButtonWrapper = styled.div`
width:auto;
button {
  margin:0px;
  margin-top: 15px;
  width: auto;
  height: auto;
  font-weight: 600;
  border-radius: 5px;
  padding: 15px 30px 15px 30px;
  background-color: ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.normal?.background};
  color: ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.normal?.text};
  border: 1px solid ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.normal?.stroke};
  font-size: 15px;
  letter-spacing: .2px;

  &:hover{
    background-color: ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.focussed?.background};
    color: ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.focussed?.text};
    border: 1px solid ${({ theme: { compositeStyle } }) => compositeStyle?.primaryButton?.focussed?.stroke};
  }
}
`
